import React, { useEffect } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import imgUrl from "../../assets/images/imageUrl";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import TreatmentRegime from "./TreatmentRegime";
// import Appointments from "./Appointments/Appointments";
import HbA1C from "./HbA1C";
import Glucose from "./Glucose";
import BMI from "./BMI";
import BloodPressure from "./BloodPressure";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import { apiServices } from "../../services/apiServices";
import moment from "moment";
import LabValues from "./LabValues";
import Alerts from "./Alerts";

// a custom render function
function renderEventContent(eventInfo) {
  return (
    <>
      <b>{eventInfo.timeText}</b>
      <i>{eventInfo.event.title}</i>
    </>
  );
}
let events;
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function PatientTabs(userData) {
  const [value, setValue] = React.useState(0);
  const [labDetails, setLabDetails] = React.useState([]);
  const [bloodGlucose, setbloodGlucose] = React.useState([]);
  const [bP, setbP] = React.useState([]);
  const [bPD, setbPD] = React.useState([]);
  const [glucose, setglucose] = React.useState([]);
  const [hBA1c, sethBA1c] = React.useState([]);
  const [cholesterol, setcholesterol] = React.useState([]);
  const [triglyceride, settriglyceride] = React.useState([]);
  const [tsh, settsh] = React.useState([]);
  const [bmi, setbmi] = React.useState([]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    let oRequest = {
      param1: userData.userData.userData.programOwners[0].program,
      param2: userData.userData.userData.orgUnit,
      param3: userData.userData.userData.trackedEntityInstance,
    };
    apiServices
      .postAPI(
        "dashboardIndicator/getPatientData/get_custom_dashboard_labdetails",
        oRequest
      )
      .then((res) => {
        setbloodGlucose(
          res.data.data.filter(
            (ele) => ele.indicatorname == "Blood glucose - Random"
          )
        );
        setbP(
          res.data.data.filter(
            (ele) => ele.indicatorname == "Blood pressure Systole(mmHg)"
          )
        );
        setbPD(
          res.data.data.filter(
            (ele) => ele.indicatorname == "Blood pressure Diastole(mmHg)"
          )
        );
        setglucose(
          res.data.data.filter(
            (ele) => ele.indicatorname == "Blood glucose - Fasting"
          )
        );
        sethBA1c(
          res.data.data.filter((ele) => ele.indicatorname == "HbA1C(%)")
        );
        setcholesterol(
          res.data.data.filter(
            (ele) => ele.indicatorname == "Total Cholesterol (mg/dl)"
          )
        );
        settriglyceride(
          res.data.data.filter((ele) => ele.indicatorname == "Triglyceride")
        );
        settsh(res.data.data.filter((ele) => ele.indicatorname == "TSH"));
        setbmi(
          res.data.data.filter((ele) => ele.indicatorname == "BMI(Kg/m2)")
        );
        setLabDetails(res.data.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
    apiServices
      .postAPI(
        "dashboardIndicator/getPatientData/get_customs_dashboard_appointmentDetails",
        oRequest
      )
      .then((res) => {
        events = res.data.data.map((item) => {
          const appointmentDateTime = moment(item.dateofappointment).format(
            "YYYY-MM-DD"
          );
          const startTime = moment(
            `${appointmentDateTime} ${item.fromtime}`,
            "YYYY-MM-DD HH:mm"
          ).toDate();

          return {
            title: item.reasonappointment || "No Reason Provided",
            start: startTime,
          };
        });
      })
      .catch((error) => {
        console.log("error", error);
      });
  }, []);
  return (
    <Box sx={{ width: "100%" }} className="patient-tabs mt-10px">
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          className="patient-vitalTab"
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab
            label="VITALS/
            MEDICAL HISTORY"
            wrapped
            {...a11yProps(0)}
            className="first-vital-tab"
          />
          <Tab label="TREATMENT REGIMEN" wrapped {...a11yProps(1)} />
          <Tab label="LAB VALUES" {...a11yProps(2)} />
          <Tab label="ALERTS" {...a11yProps(3)} />
        </Tabs>
      </Box>
      <div className="mx-24px mt-20px">
        <CustomTabPanel value={value} index={0}>
          <div className="first-tab">
            <Card variant="outlined">
              <CardContent className="pt-100 pb-8px">
                <div className="first-card">
                  <h5 className="mt-0">Basic Lab Values</h5>
                  <div>
                    <Grid container spacing={2} className="lab-firstSection">
                      <Grid item xs={3}>
                        <div>
                          <div className="d-flex justify-content-center align-items-center">
                            <img
                              src={imgUrl.arrowup_icon}
                              className="arrow-icon"
                            ></img>
                            <img
                              src={imgUrl.labhsb_icon}
                              className="lab-icon"
                            ></img>
                            <h4 className="mt-0 mb-0">
                              {hBA1c[0] ? hBA1c[0].indicatorvalue : ""}
                            </h4>
                          </div>
                          <div>
                            <h6 className="mt-15px mb-0">HbA1C</h6>
                            <p className="mt-5px mb-0"></p>
                            <p className="mt-5px">
                              (
                              {hBA1c[0]
                                ? moment(hBA1c[0].indicatordate).format(
                                    "DD.MM.YYYY"
                                  )
                                : ""}
                              ){" "}
                            </p>
                          </div>
                        </div>
                      </Grid>
                      <Grid item xs={3}>
                        <div>
                          <div className="d-flex justify-content-center align-items-center">
                            <img
                              src={imgUrl.arrowdown_icon}
                              className="arrow-icon"
                            ></img>
                            <img
                              src={imgUrl.lab_three}
                              className="lab-icon"
                            ></img>
                            <h4 className="mt-0 mb-0">
                              {glucose[0] ? glucose[0].indicatorvalue : ""}
                            </h4>
                          </div>
                          <div>
                            <h6 className="mt-15px mb-0">Glucose Fasting</h6>
                            <p className="mt-5px mb-0">(mg/dl)</p>
                            <p className="mt-5px">
                              (
                              {glucose[0]
                                ? moment(glucose[0].indicatordate).format(
                                    "DD.MM.YYYY"
                                  )
                                : ""}
                              ){" "}
                            </p>
                          </div>
                        </div>
                      </Grid>
                      <Grid item xs={3}>
                        <div>
                          <div className="d-flex justify-content-center align-items-center">
                            <img
                              src={imgUrl.arrowup_icon}
                              className="arrow-icon"
                            ></img>
                            <img
                              src={imgUrl.lab_three}
                              className="lab-icon"
                            ></img>
                            <h4 className="mt-0 mb-0">
                              {bloodGlucose[0]
                                ? bloodGlucose[0].indicatorvalue
                                : ""}
                            </h4>
                          </div>
                          <div>
                            <h6 className="mt-15px mb-0">Glucose Random </h6>
                            <p className="mt-5px mb-0">(mg/dl)</p>
                            <p className="mt-5px">
                              (
                              {bloodGlucose[0]
                                ? moment(bloodGlucose[0].indicatordate).format(
                                    "DD.MM.YYYY"
                                  )
                                : ""}
                              ){" "}
                            </p>
                          </div>
                        </div>
                      </Grid>
                      <Grid item xs={3}>
                        <div>
                          <div className="d-flex justify-content-center align-items-center">
                            <img
                              src={imgUrl.arrowdown_icon}
                              className="arrow-icon"
                            ></img>
                            <img
                              src={imgUrl.lab_two}
                              className="lab-icon"
                            ></img>
                            <h4 className="mt-0 mb-0">
                              {bP[0] && bPD[0]
                                ? bP[0].indicatorvalue +
                                  "/" +
                                  bPD[0].indicatorvalue
                                : ""}
                            </h4>
                          </div>
                          <div>
                            <h6 className="mt-15px mb-0">Blood Pressure</h6>
                            <p className="mt-5px">
                              (
                              {bP[0]
                                ? moment(bP[0].indicatordate).format(
                                    "DD.MM.YYYY"
                                  )
                                : ""}
                              ){" "}
                            </p>
                          </div>
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                </div>
              </CardContent>
            </Card>
            <Card variant="outlined" className="mt-30px">
              <CardContent className="pt-100 pb-5px mt-10px">
                <div className="first-card">
                  {/* <h5 className="mt-0">BASIC LAB VALUES</h5> */}
                  <div>
                    <Grid container spacing={2} className="lab-firstSection">
                      <Grid item xs={3}>
                        <div>
                          <div className="d-flex justify-content-center align-items-center">
                            <img
                              src={imgUrl.arrowup_icon}
                              className="arrow-icon"
                            ></img>
                            <img
                              src={imgUrl.lab_one}
                              className="lab-icon"
                            ></img>
                            <h4 className="mt-0 mb-0">
                              {bmi[0] ? bmi[0].indicatorvalue : ""}
                            </h4>
                          </div>
                          <div>
                            <h6 className="mt-15px mb-0">BMI</h6>
                            <p className="mt-5px">
                              (
                              {bmi[0]
                                ? moment(bmi[0].indicatordate).format(
                                    "DD.MM.YYYY"
                                  )
                                : ""}
                              ){" "}
                            </p>
                          </div>
                        </div>
                      </Grid>
                      <Grid item xs={3}>
                        <div>
                          <div className="d-flex justify-content-center align-items-center">
                            <img
                              src={imgUrl.arrowdown_icon}
                              className="arrow-icon"
                            ></img>
                            <img
                              src={imgUrl.labchol_icon}
                              className="lab-icon"
                            ></img>
                            <h4 className="mt-0 mb-0">
                              {cholesterol[0]
                                ? cholesterol[0].indicatorvalue
                                : ""}
                            </h4>
                          </div>
                          <div>
                            <h6 className="mt-15px mb-0">Total Cholesterol</h6>
                            <p className="mt-5px mb-0">(mg/dl)</p>
                            <p className="mt-5px">
                              (
                              {cholesterol[0]
                                ? moment(cholesterol[0].indicatordate).format(
                                    "DD.MM.YYYY"
                                  )
                                : ""}
                              ){" "}
                            </p>
                          </div>
                        </div>
                      </Grid>
                      <Grid item xs={3}>
                        <div>
                          <div className="d-flex justify-content-center align-items-center">
                            <img
                              src={imgUrl.arrowup_icon}
                              className="arrow-icon"
                            ></img>
                            <img
                              src={imgUrl.labtri_icon}
                              className="lab-icon"
                            ></img>
                            <h4 className="mt-0 mb-0">
                              {triglyceride[0]
                                ? triglyceride[0].indicatorvalue
                                : ""}
                            </h4>
                          </div>
                          <div>
                            <h6 className="mt-15px mb-0">Triglyceride</h6>
                            <p className="mt-5px mb-0">(mg/dl)</p>
                            <p className="mt-5px">
                              (
                              {triglyceride[0]
                                ? moment(triglyceride[0].indicatordate).format(
                                    "DD.MM.YYYY"
                                  )
                                : ""}
                              ){" "}
                            </p>
                          </div>
                        </div>
                      </Grid>
                      <Grid item xs={3}>
                        <div>
                          <div className="d-flex justify-content-center align-items-center">
                            <img
                              src={imgUrl.arrowdown_icon}
                              className="arrow-icon"
                            ></img>
                            <img
                              src={imgUrl.labtsh_icon}
                              className="lab-icon"
                            ></img>
                            <h4 className="mt-0 mb-0">
                              {tsh[0] ? tsh[0].indicatorvalue : ""}
                            </h4>
                          </div>
                          <div>
                            <h6 className="mt-15px mb-0">TSH</h6>
                            <p className="mt-5px mb-0">(mlU/L)</p>
                            <p className="mt-5px">
                              (
                              {tsh[0]
                                ? moment(tsh[0].indicatordate).format(
                                    "DD.MM.YYYY"
                                  )
                                : ""}
                              ){" "}
                            </p>
                          </div>
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
          <div className="second-ChartSection mt-15px">
            <Grid container spacing={2} className="mt-0">
              <Grid item xs={12} md={6}>
                <Card variant="outlined" className="bg-lightgrey">
                  <CardContent>
                    <div className="">
                      <h5 className="mt-0">HbA1C Trend</h5>
                    </div>
                    <HbA1C userData={userData} />
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} md={6} className="pr-0px">
                <Card variant="outlined" className="bg-lightgrey">
                  <CardContent>
                    <div className="">
                      <h5 className="mt-0">Glucose</h5>
                    </div>
                    <Glucose userData={userData} />
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Card variant="outlined" className="bg-lightgrey">
                  <CardContent>
                    <div className="">
                      <h5 className="mt-0">BMI Chart</h5>
                    </div>
                    <BMI userData={userData} />
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} md={6} className="pr-0px">
                <Card variant="outlined" className="bg-lightgrey">
                  <CardContent>
                    <div className="">
                      <h5 className="mt-0">Blood Pressure</h5>
                    </div>
                    <BloodPressure userData={userData} />
                  </CardContent>
                </Card>
              </Grid>
            </Grid>

            <Grid container spacing={2} className="mt-15px">
              <Grid item xs={12} className="pr-0px">
                <Card
                  variant="outlined"
                  className="bg-lightgrey calender-patient-section"
                >
                  <CardContent>
                    <div className="">
                      <h5 className="mt-0 mb-0">Appointments</h5>
                    </div>
                    <FullCalendar
                      selectable={true}
                      plugins={[dayGridPlugin, interactionPlugin]}
                      initialView="dayGridMonth"
                      weekends={true}
                      events={events}
                      dayMinWidth="40px"
                      contentHeight="400"
                      scrollToTime={new Date()}
                      dayMaxEvents={0}
                      eventContent={renderEventContent}
                      themeSystem="Simplex"
                      eventTimeFormat={{
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false,
                      }}
                    />
                    {/* <Appointments/> */}
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </div>
          <div className="card-risk">
            <Card variant="outlined" className="mt-30px">
              <CardContent className="pt-100 pb-8px mt-10px">
                <Grid container spacing={2} className="pb-8px">
                  <Grid
                    item
                    xs={3}
                    className="flex-direction-column left-ley-factor"
                  >
                    <h5 className="mt-0 text-right">Risk Factors </h5>
                    <div className="tick-img-section">
                      <div className="d-flex justify-content-end align-items-center">
                        <p>CELIAC DISEASE</p>
                        <img src={imgUrl.tick_icon}></img>
                      </div>

                      <div className="d-flex justify-content-end align-items-center">
                        <img
                          src={imgUrl.pin_icon}
                          style={{ marginLeft: "-33px" }}
                          className="w-10"
                        ></img>
                        <p>MENTAL HEALTH</p>
                        <img src={imgUrl.tick_icon}></img>
                      </div>
                      <div className="d-flex justify-content-end align-items-center">
                        <p>SMOKING</p>
                        <img src={imgUrl.tick_icon}></img>
                      </div>
                      <div className="d-flex justify-content-end align-items-center">
                        <p>ALCOHOLISM</p>
                        <img src={imgUrl.tick_icon}></img>
                      </div>
                    </div>
                  </Grid>
                  <Grid
                    item
                    xs={5}
                    className="flex-direction-column middle-key-factor"
                  >
                    <h5 className="mt-0"></h5>
                    <div>
                      <div className="">
                        <div className="border-left">
                          <div className="profile-border">
                            <img
                              src={imgUrl.profile_user}
                              className="profile-img"
                            ></img>
                            {/* <AccountCircleIcon className="profile-user"></AccountCircleIcon> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={4} className="flex-direction-column">
                    <h5 className="mt-0">Complication</h5>
                    <div className="tick-img-section tick-right-section">
                      <div className="d-flex align-items-center">
                        <img src={imgUrl.tick_icon}></img>
                        <p>DKA (21.02.2021)</p>
                      </div>

                      <div className="d-flex align-items-center">
                        <img src={imgUrl.tick_icon}></img>

                        <p>RETINOPAHY (I 21.02.2021)</p>
                        <img
                          src={imgUrl.camera_icon}
                          className="w-8 mx-4px"
                        ></img>
                      </div>
                      <div className="d-flex align-items-center">
                        <img src={imgUrl.tick_icon}></img>
                        <p>NEPHROPATHY (21.02.2021)</p>
                      </div>
                      <div className="d-flex align-items-center">
                        <img src={imgUrl.tick_icon}></img>
                        <p>CVA</p>
                      </div>
                      <div className="d-flex align-items-center">
                        <img src={imgUrl.tick_icon}></img>
                        <p>HYPOGLYCEMIC EVENTS</p>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <div className="second-tab mt-20px">
            <TreatmentRegime />
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          <div className="second-tab mt-20px">
            <LabValues />
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={value} index={3}>
          <div className="second-tab mt-20px">
            <Alerts />
          </div>
        </CustomTabPanel>
      </div>
    </Box>
  );
}
